<template>
  <artmisads-modal
    :open="open"
    :title="t('seller.accBonusProgram.tierRatesTitle')"
    :width="640"
    :maskClosable="false"
    :footer="null"
    :onCancel="() => (open = false)"
    :destroyOnClose="true"
  >
    <artmisads-table
      :columns="columns"
      :data-source="dataSource"
      :loading="load"
      :pagination="false"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'targetSales'">
          {{ currencySymbol }} {{ formatAmount(record.targetSales) }}
        </template>
        <template v-if="column.key === 'bonusRate'"> {{ record.bonusRate*100 }}% </template>
      </template>
    </artmisads-table>
  </artmisads-modal>
</template>

<script setup>
import { ref, computed, defineExpose } from 'vue';
import { useI18n } from 'vue-i18n';
import { accBonusProgramApi } from '@/server/index';
import { CURRENCY_DATA_MAPPER } from '@/contants/common';


const { t } = useI18n();
const open = ref(false);
const load = ref(false);
const dataSource = ref([]);
const currencyCode = ref('USD');

const currencySymbol = computed(() => CURRENCY_DATA_MAPPER[currencyCode.value] || '$');

const columns = computed(() => [
  {
    title: t('seller.accBonusProgram.colTierLevel'),
    dataIndex: 'tierLevel',
    key: 'tierLevel',
  },
  {
    title: t('seller.accBonusProgram.colTargetSales'),
    dataIndex: 'targetSales',
    key: 'targetSales',
  },
  {
    title: t('seller.accBonusProgram.colBonusRate'),
    dataIndex: 'bonusRate',
    key: 'bonusRate',
  },
]);

const formatAmount = (val) => Number(val || 0).toFixed(2);

const fetchList = async (programId) => {
  load.value = true;
  try {
    const res = await accBonusProgramApi.getProgramTierRates({ programId });
    if (res?.success && res?.data) {
      dataSource.value = Array.isArray(res.data) ? res.data : res.data.data || [];
    } 
  } catch {
   
  } finally {
    load.value = false;
  }
};

const show = (row) => {
  dataSource.value = row.tierRates;
  currencyCode.value = row.currency || 'USD';
  open.value = true;
};

defineExpose({ show });
</script>
